import {v4 as uuidv4} from 'uuid';
import {SeriesNoticeV2Vo} from '../../common/shared/api/nicolas/vo/SeriesNoticeV2Vo.interface';
import {SeriesNoticeListContainer} from '../generated/types';
import {createSeriesNotice} from './SeriesNotice';

export function createSeriesNoticeListContainer({
  current_page,
  total_count,
  notice_list,
  is_end,
}: {
  current_page: number;
  total_count: number;
  notice_list: SeriesNoticeV2Vo[];
  is_end: boolean;
}): SeriesNoticeListContainer {
  return {
    id: uuidv4(),
    totalCount: total_count,
    noticeList: notice_list.map(createSeriesNotice),
    currentPage: current_page,
    isEnd: is_end,
  };
}
